import React, { ReactElement, useEffect } from 'react';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import ClientForm from '../ClientForm';
import { useClientFormContext } from '../ClientFormContext';
import { submitE2EFlowConfigFactory } from '../utils/submit';
import E2EFlowSection from '../../../components/Feature/Scheduled/E2EFlowSection';
import { ClientFeatureConfig, E2EFlow } from '../../../types/Feature';
import { useScheduledFeatureContext } from '../../../components/Feature/Scheduled/ScheduledFeatureContext';

const ClientScheduled: React.FC = (): React.ReactElement => {
    const { client, data, formConfig, isLoadingData, setIsLoadingData } = useClientFormContext();

    const { shops, setShops } = useScheduledFeatureContext();

    const [currentE2EFlowConfig, setCurrentE2EFlowConfig] = React.useState<E2EFlow>({
        enabled: false,
        shopList: [],
    });

    useEffect(() => {
        if (data.e2eFlow?.config) {
            setCurrentE2EFlowConfig(data.e2eFlow?.config);
            setShops(data.e2eFlow?.config.shopList);
        }
    }, [data.e2eFlow?.config]);

    const submitForm = async (): Promise<void> => {
        if (client && currentE2EFlowConfig) {
            // The shop data is handle in useScheduledFeatureContext,
            const clientFeatureConfigE2EFlow = {
                ...data.e2eFlow,
                config: {
                    enabled: currentE2EFlowConfig.enabled,
                    shopList: shops,
                },
            } as ClientFeatureConfig<E2EFlow>;

            setIsLoadingData(true);
            try {
                await submitE2EFlowConfigFactory(client.id, clientFeatureConfigE2EFlow);
            } catch (e) {
                // eslint-disable-next-line no-alert
                alert(`Something went wrong, data not saved, try again, Error : ${e.message}`);
                return;
            } finally {
                setIsLoadingData(false);
            }
            setCurrentE2EFlowConfig(currentE2EFlowConfig);
        }
    };

    if (isLoadingData) return <div>Loading...</div>;

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm name="scheduled" submitForm={submitForm}>
                        {({ form }): ReactElement => (
                            <>
                                <E2EFlowSection
                                    e2eFlowConfig={currentE2EFlowConfig}
                                    setE2EFlowConfig={setCurrentE2EFlowConfig}
                                    isDetailMode={formConfig.isDetailMode}
                                />
                            </>
                        )}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default ClientScheduled;
